/**
 * Solutions dropdown nav items.
 *
 * Kept in a separate file from `SOLUTION_SEGMENTS` (which carries the full
 * landing-page content — `capabilities`, `problemStatement`, `useCases`,
 * `faqs`, …) so the client bundle for `HomepageHeader` only ships these
 * 3 `{name, slug}` pairs. JS object literals can't be tree-shaken
 * field-by-field, so importing `SOLUTION_SEGMENTS` into a client component
 * pulls every nested string into the browser bundle on every public route.
 *
 * Slugs must match the canonical `slug` field in `segments.ts`. Drift is
 * checked by `nav.test.ts`, runnable via `pnpm --filter b3os-web run test`.
 * Note: vitest is not yet wired into the b3os-web GitHub Actions workflow
 * (only b3os-actions and anyspend-service run vitest in CI today), so this
 * check is local-only — run it before merging changes here.
 *
 * User-facing labels: short and customer-friendly. Sorted alphabetically.
 */
export const SOLUTION_NAV_ITEMS: ReadonlyArray<{ name: string; slug: string }> = [
  { name: "Developers", slug: "workflow-automation-web3-developers" },
  { name: "Enterprises", slug: "enterprise-blockchain-workflow-automation" },
  { name: "Traders", slug: "crypto-trading-workflow-automation" },
];
